var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payment"}},[(!_vm.failed)?_c('banner'):_vm._e(),(_vm.failed)?_c('bannerFailed'):_vm._e(),(!_vm.failed)?_c('steps'):_vm._e(),(_vm.failed)?_c('stepsFailed'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }